import logger from '../log';

const log = logger.getLogger(__filename);

enum AGENT_COMMAND {
  MANIFEST_PROGRESS = 'manifestProgress',
  HANDLE_ERROR = 'handleError',
  HTTP_ERROR = 'httpError',
  CANCEL_STREAM = 'cancelStream',
  SWITCH_TO_CDN = 'switchToCDN',
  ART_STATUS = 'artStatus',
  NOP = 'NOP'
}

const AGENT_PARAMS = {
  PERCENT_READY: '100',
  FAILURE_CODE: 404,
  ART_STATUS_ENDED: 'ended',
  ART_STATUS_SHUTDOWN: 'shutdown'
};

export default function(options: {
  cmd: string;
  params: {
    percent?: string;
    message?: string;
    status: string;
    code?: number | string;
  };
  onProgress: (progress: number) => void;
  onReady: () => void;
  switchToCDN: () => void;
  retry: () => void;
}): void {
  const { cmd, params, onProgress, onReady, switchToCDN, retry } = options;
  const { percent, message, status, code } = params || {};
  log.debug(`ecdn10: handling command ${cmd} with params:`, params);
  switch (cmd) {
    case AGENT_COMMAND.NOP:
      retry();
      return;
    case AGENT_COMMAND.MANIFEST_PROGRESS: {
      if (percent === AGENT_PARAMS.PERCENT_READY) {
        onReady();
      } else {
        if (percent) {
          onProgress(parseInt(percent));
        } else {
          retry();
        }
      }
      return;
    }
    case AGENT_COMMAND.HANDLE_ERROR:
    case AGENT_COMMAND.HTTP_ERROR: {
      if (code == AGENT_PARAMS.FAILURE_CODE) {
        log.fatal(
          `ecdn10:failed processing agent command ${cmd} with message: ${message ||
            ''}`
        );
        switchToCDN();
      }
      return;
    }
    case AGENT_COMMAND.CANCEL_STREAM:
    case AGENT_COMMAND.SWITCH_TO_CDN: {
      log.fatal(
        `ecdn10:failed processing agent command ${cmd} with message: ${message ||
          ''}`
      );
      switchToCDN();
      return;
    }
    case AGENT_COMMAND.ART_STATUS: {
      if (
        status === AGENT_PARAMS.ART_STATUS_ENDED ||
        status === AGENT_PARAMS.ART_STATUS_SHUTDOWN
      ) {
        log.fatal(
          `ecdn10:failed processing agent command: ${cmd} with status: ${status}`
        );
        switchToCDN();
      }
      return;
    }
    default:
      return;
  }
}
